import React from 'react';

interface Props {
  size: string
  value: number
  min: number
  max: number
  results?: string
  className?: string
}


const BarValue: React.FC<Props> = (props: Props) => {
  const percent = 100 * props.value / (props.max - props.min);
  const barWidth = percent + "%";
  const hClass = props.size === "large" ? "h-8" : "h-4";
  const extraClass = props.className ? " " + props.className : "";
  let resultsStyle = {};
  let resultsClass = "!text-indigo-1000 mr-2";
  if (percent < 5) {
    const leftP = percent + 2 +  "%";
    resultsStyle = { left: leftP};
    resultsClass = "text-white absolute"
  }

  if (props.size === "small") {
    resultsClass += " z-title4";
  }
  let borderRadius = "8px 0 0 8px";
  if (percent > 98) {
    borderRadius = "8px";
  }

  return (
    <div className={"bg-indigo-700 w-full relative " + hClass + extraClass} style={{borderRadius: "8px"}}>
      <div className={"bg-peach-500 flex items-center justify-end " + hClass}
           style={{width: barWidth, borderRadius: borderRadius}}>
        {
          props.results &&
            <div className={resultsClass} style={resultsStyle}>
              {props.results}
            </div>
        }
      </div>
    </div>
  )
}

export default BarValue;